export default __webpack_public_path__ + "static/media/compare-mobile.d668cd0e.svg";